import { Ticket, TicketType } from '../components/TicketsPanel/Ticket';
import { Fragment } from '../components/Fragment/Fragment';
import styles from './format.module.scss';
import { CurrencySmallIcon } from '../components/CurrencySmallIcon/CurrencySmallIcon';
import interactiveDrawPrizeIcon from '../icons/prize_gray.jpg';
import automaticDrawPrizeIcon from '../icons/prize_color.jpg';

interface PlaceholderComponentsMap {
    [key: string]: (key: string) => React.ReactElement;
}

export const PLACEHOLDER_COMPONENTS: PlaceholderComponentsMap = {
    '[balance]': (key: string) => <CurrencySmallIcon value={0} />,
    '[regularTickets]': (key: string) => <span className={styles.ticketStyles}><Ticket key={key} type={TicketType.Regular} hideValue={true} value={0} /></span>,
    '[rareTickets]': (key: string) => <span className={styles.ticketStyles}><Ticket key={key} type={TicketType.Rare} hideValue={true} value={0} /></span>,
    '[epicTickets]': (key: string) => <span className={styles.ticketStyles}><Ticket key={key} type={TicketType.Epic} hideValue={true} value={0} /></span>,
    '[legendaryTickets]': (key: string) => <span className={styles.ticketStyles}><Ticket key={key} type={TicketType.Legendary} hideValue={true} value={0} /></span>,
    '[fragments]': (key: string) => <span className={styles.fragmentsStyles}><Fragment key={key} /></span>,
    '[interactiveDrawPrize]': (_key: string) => <img src={ interactiveDrawPrizeIcon } className={styles.icon} alt="" />,
    '[fragmentsDrawPrize]': (key: string) => <span className={styles.fragmentsStyles}><Fragment key={key} /></span>,
    '[automaticDrawPrize]': (_key: string) => <img src={ automaticDrawPrizeIcon } className={styles.icon} alt="" />,
};

const getPlaceholdersRegex = (): RegExp => {
    const placeholders = Object.keys(PLACEHOLDER_COMPONENTS)
        .map(placeholder => placeholder.replace(/[[\]]/g, '\\$&'))
        .join('|');
    
    return new RegExp(`(${placeholders})`, 'g');
};

export const parsePlaceholders = (text: string, keyPrefix: string = ''): React.ReactElement[] => {
    if (!text) return [];

    const regex = getPlaceholdersRegex();
    const parts: React.ReactElement[] = [];
    let lastIndex: number = 0;
    let match: RegExpExecArray | null;

    regex.lastIndex = 0;

    while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
            parts.push(
                <span key={`${keyPrefix}-text-${parts.length}`}>
                    {text.substring(lastIndex, match.index)}
                </span>
            );
        }

        const placeholder: string = match[0];
        const componentFactory = PLACEHOLDER_COMPONENTS[placeholder];
        
        if (componentFactory) {
            parts.push(componentFactory(`${keyPrefix}-comp-${parts.length}`));
        } else {
            parts.push(
                <span key={`${keyPrefix}-fallback-${parts.length}`}>
                    {placeholder}
                </span>
            );
        }

        lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
        parts.push(
            <span key={`${keyPrefix}-text-${parts.length}`}>
                {text.substring(lastIndex)}
            </span>
        );
    }

    return parts;
};

export const formatMessage = (message: string): React.ReactElement[] => {
    if (!message) return [];

    const paragraphs = message.split('[TEXT_SPLITTER]');

    return paragraphs.map((paragraph: string, paragraphIndex: number): React.ReactElement => {
        const parts = parsePlaceholders(paragraph, `p-${paragraphIndex}`);
        
        return <p key={`p-${paragraphIndex}`}>{parts}</p>;
    });
};